module.exports = __WEBPACK_EXTERNAL_MODULE_159__;


//////////////////
// WEBPACK FOOTER
// external "react-day-picker"
// module id = 159
// module chunks = 0